import React, { useState, useEffect } from "react";
import http from "./../../../Services/http";
import "./MangeFoods.css";
import { Link } from "react-router-dom";
import Loader from "react-loader-spinner";

const MangeFoods = ({ user }) => {
  const [foods, setFoods] = useState();
  // const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchFoods = async () => {
      const { data } = await http.get("/foods");
      setFoods(data.foods);
    };

    fetchFoods();
  }, []);

  if (!foods)
    return <Loader type="ThreeDots" color="#ef92c8" height={100} width={100} />;

  return (
    <React.Fragment>
      <div className="mange__foods">
        <Link to="/dashborad/foods/new" className="btn link btn-signup b-f-s">
          Add New
        </Link>
        <div className="mange__foods--content">
          {foods.length ===0  ? (
             <div className='wrarring'>Loading </div>
          ) : (
            foods.map((food) => (
              <div key={food._id} className="mange__food">
                <div className="mange__img--container">
                  <img
                    className="mange__img"
                    src={process.env.REACT_APP_IMAGES_URL + food.foodImage}
                    alt="food"
                  />
                </div>
                <div className="mange__text">
                  <h3 className="mange__title">{food.title}</h3>
                  <p className="mange__desc">{food.desc}</p>
                </div>

                <div className="mange__info">
                  <p className="mange__price">{food.price} $</p>
                </div>

                {user && user.isAdmin ? (
                  <div className="mange__links">
                    <Link
                      to={`/dashborad/foods/delete/${food._id}`}
                      className="link btn btn-signup m-r-s"
                    >
                      Delete
                    </Link>
                    <Link
                      to={`/dashborad/foods/edit/${food._id}`}
                      className="link btn btn-signup"
                    >
                      Edit
                    </Link>
                  </div>
                ) : null}
              </div>
            ))
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default MangeFoods;
